import { useEditingCarDraft } from './useEditingCarDraft';

/**
 * @deprecated Prefer {@link useEditingCarDraft}. Thin alias for add-flow pages that
 * still expect `successfullUpdatedEditingCarId` — does **not** call GET_ALL_CARS.
 */
export const useUpdateEditCarStoreHook = () => {
  const { editingCar, ready } = useEditingCarDraft();

  return {
    editingCar,
    successfullUpdatedEditingCarId: ready,
  };
};
